import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { usePermissions } from "../../../../utils/permissions";

const tabs = [
  {
    key: "niveles",
    label: "Niveles",
    to: "/dashboard/coordinacion/niveles",
    permissionList: "niveles.listar",
    permissionAccess: "niveles.acceso",
  },
  {
    key: "especialidades",
    label: "Especialidades",
    to: "/dashboard/coordinacion/especialidades",
    permissionList: "especialidades.listar",
    permissionAccess: "especialidades.acceso",
  },
  {
    key: "cursos",
    label: "Cursos",
    to: "/dashboard/coordinacion/cursos",
    permissionList: "cursos.listar",
    permissionAccess: "cursos.acceso",
  },
  {
    key: "materias",
    label: "Materias",
    to: "/dashboard/coordinacion/materias",
    permissionList: "materias.listar",
    permissionAccess: "materias.acceso",
  },
  {
    key: "docentes",
    label: "Docentes",
    to: "/dashboard/coordinacion/docentes",
    permissionList: "docentes.listar",
    permissionAccess: "docentes.acceso",
  },
  {
    key: "malla",
    label: "Malla Curricular",
    to: "/dashboard/coordinacion/malla",
    permissionList: "malla.listar",
    permissionAccess: "malla.listar",
  },
  {
    key: "ciclos",
    label: "Ciclos",
    to: "/dashboard/coordinacion/ciclos",
    permissionList: "ciclos.listar",
    permissionAccess: "ciclos.acceso",
  },
  {
    key: "promociones",
    label: "Promociones",
    to: "/dashboard/coordinacion/promociones",
    permissionList: "promociones.listar",
    permissionAccess: "promociones.acceso",
  },
];

const getActiveKey = (pathname) => {
  if (pathname.includes("/coordinacion/especialidades")) return "especialidades";
  if (pathname.includes("/coordinacion/cursos")) return "cursos";
  if (pathname.includes("/coordinacion/materias")) return "materias";
  if (pathname.includes("/coordinacion/docentes")) return "docentes";
  if (pathname.includes("/coordinacion/malla")) return "malla";
  if (pathname.includes("/coordinacion/ciclos")) return "ciclos";
  if (pathname.includes("/coordinacion/promociones")) return "promociones";
  return "niveles";
};

export default function CoordinacionTabs() {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const activeKey = getActiveKey(location.pathname);
  const wrapperRef = useRef(null);
  const visibles = tabs.filter(
    (tab) => hasPermission(tab.permissionAccess) || hasPermission(tab.permissionList)
  );

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const activeEl = wrapper.querySelector(".nav-link.active");
    if (!activeEl) return;
    const elLeft = activeEl.offsetLeft;
    const elWidth = activeEl.offsetWidth;
    const wrapperWidth = wrapper.offsetWidth;
    wrapper.scrollLeft = elLeft - wrapperWidth / 2 + elWidth / 2;
  }, [activeKey]);

  if (!visibles.length) return null;

  return (
    <div className="dashboard-tabs-wrapper mb-3" ref={wrapperRef}>
    <ul className="nav nav-tabs dashboard-tabs">
      {visibles.map((tab) => {
        const isActive = activeKey === tab.key;
        const canList = hasPermission(tab.permissionList);
        return (
          <li className="nav-item" key={tab.key}>
            {canList ? (
              <Link className={`nav-link ${isActive ? "active" : ""}`} to={tab.to}>
                {tab.label}
              </Link>
            ) : (
              <button
                type="button"
                className={`nav-link disabled ${isActive ? "active" : ""}`}
                aria-disabled="true"
                disabled
                title="Sin permiso para listar"
              >
                {tab.label}
              </button>
            )}
          </li>
        );
      })}
    </ul>
    </div>
  );
}
